import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFilterComponent } from './date-filter.component';
import { DropdownModule } from '../dropdown/dropdown.module';
import { DatepickerInputModule } from '../datepicker-input/datepicker-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [DateFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    DatepickerInputModule
  ],
  exports: [DateFilterComponent]
})
export class DateFilterModule { }
